import React from 'react';
import { Typography } from '@material-ui/core';
import ContentList from './ContentList';

const QuestionsToAsk = ({ questions }) => {
  return (
    <>
      <Typography variant="body1" gutterBottom>
        Questions to ask:
      </Typography>
      <ContentList>
        {questions.map((q, i) => (
          <Typography key={q} variant="body1" gutterBottom>
            <strong>{i + 1}.</strong> {q}
          </Typography>
        ))}
      </ContentList>
    </>
  );
};

export default QuestionsToAsk;
